import React from 'react';
import ToastMessage from 'relements/build/esm/decorators/toastMessage';
import { alertEnded } from 'actions/BotActions';

@ToastMessage()
export default class Alert extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (!this.props.active && nextProps.active) {
      this.props.activateToastMessage({
        title: nextProps.message,
        type: nextProps.messageType || 'POSITIVE',
        timeout: nextProps.alertLength,
      });
      setTimeout(alertEnded, 0);
    }
  }

  render() {
    return null;
  }
}
